import { Dispatch, SetStateAction, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./NotFoundScreen.css"
import logo from "../img/logo_blue.png";
interface NotFoundScreenProps {
  setIsNotFound: Dispatch<SetStateAction<boolean>>;
}

function NotFoundScreen(props: NotFoundScreenProps) {
    const navigate = useNavigate();

    useEffect(() => {
      props.setIsNotFound(true);
      return () => {
        props.setIsNotFound(false);
      }
    })

    return (
        <div className="notfound-container">
            <img src={logo} alt="로고" className="notfound-logo"/>
            <h1>404</h1>
            <h3>죄송합니다. 현재 찾을 수 없는 페이지를 요청하셨습니다.</h3>
            <div className="p-container">
              <p>존재하지 않는 주소를 입력하셨거나,</p>
              
              <p>요청하신 페이지의 주소가 변경 또는 삭제되었습니다.</p>
              <p>궁금한 점이 있으시면 언제든 <strong>고객센터</strong>를 통해 문의해 주세요.</p>
            </div>
            <a href="mailto:techsupport@ksic.net">techsupport@ksic.net</a>
            <button 
              className="home-button" 
              onClick={() => {
                props.setIsNotFound(false);
                navigate("/");
              }}>
                홈으로 이동
            </button>
        </div>
    );
}

export default NotFoundScreen;
